import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

firebase.initializeApp({
    apiKey: "AIzaSyCzLD49jRGNfsfD7L9mvb0Ju3ajHSv265Y",
    authDomain: "hs-furtwangen-mdsd.firebaseapp.com",
    databaseURL: "https://hs-furtwangen-mdsd.firebaseio.com",
    projectId: "hs-furtwangen-mdsd",
    storageBucket: "hs-furtwangen-mdsd.appspot.com",
    messagingSenderId: "384845385161",
    appId: "1:384845385161:web:997f245e5949ec79526c18"
 });

export default firebase;


// WEBPACK FOOTER //
// ./src/firebase.js